import React from 'react';
import styles from './BedsAndBaths.module.scss';
import { UnitTour } from '../../types/Unit/Unit';

const BedIcon = () => (
    <svg
        width="17"
        height="13"
        viewBox="0 0 17 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.42857 0C1.42982 0 0.607143 0.83881 0.607143 1.85714V6.05429C0.236786 6.396 0 6.88505 0 7.42857V13H3.03571V11.7619H13.9643V13H17V7.42857C17 6.88505 16.7632 6.396 16.3929 6.05429V1.85714C16.3929 0.83881 15.5702 0 14.5714 0H2.42857ZM2.42857 1.2381H14.5714C14.9084 1.2381 15.1786 1.51357 15.1786 1.85714V5.57143H13.9643V4.95238C13.9643 3.93405 13.1416 3.09524 12.1429 3.09524H9.71429C9.24861 3.09524 8.82361 3.28095 8.5 3.5781C8.16797 3.26918 7.7352 3.09709 7.28571 3.09524H4.85714C3.85839 3.09524 3.03571 3.93405 3.03571 4.95238V5.57143H1.82143V1.85714C1.82143 1.51357 2.09161 1.2381 2.42857 1.2381ZM4.85714 4.33333H7.28571C7.62268 4.33333 7.89286 4.60881 7.89286 4.95238V5.57143H4.25V4.95238C4.25 4.60881 4.52018 4.33333 4.85714 4.33333ZM9.71429 4.33333H12.1429C12.4798 4.33333 12.75 4.60881 12.75 4.95238V5.57143H9.10714V4.95238C9.10714 4.60881 9.37732 4.33333 9.71429 4.33333ZM1.82143 6.80952H15.1786C15.5155 6.80952 15.7857 7.085 15.7857 7.42857V11.7619H15.1786V10.5238H8.5H1.82143V11.7619H1.21429V7.42857C1.21429 7.085 1.48446 6.80952 1.82143 6.80952Z"
            fill="#333333"
        />
    </svg>
);

const BathIcon = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_8847_785)">
            <path
                d="M0 7.5H15M4.5 12.5H10.5M4.5 12.5C3.70435 12.5 2.94129 12.1839 2.37868 11.6213C1.81607 11.0587 1.5 10.2956 1.5 9.5V3.5C1.5 2.70435 1.81607 1.94129 2.37868 1.37868C2.94129 0.81607 3.70435 0.5 4.5 0.5H6.5V2M4.5 12.5V15M10.5 12.5C11.2956 12.5 12.0587 12.1839 12.6213 11.6213C13.1839 11.0587 13.5 10.2956 13.5 9.5V7.5M10.5 12.5V15M5 3.5H8"
                stroke="#333333"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <clipPath id="clip0_8847_785">
                <rect width="15" height="15" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

interface BedsAndBathsProps {
    unit: UnitTour;
}

export default function BedsAndBaths({ unit }: BedsAndBathsProps) {
    const { numBed, numBath } = unit;

    if (numBed !== 0 && !numBed && !numBath) return null;

    return (
        <div className={styles.bedsAndBaths}>
            {numBed === 0 ? 'Studio' : null}
            {numBed && numBed > 0 ? (
                <>
                    {numBed}
                    <BedIcon />
                </>
            ) : null}
            {numBath && numBath > 0 ? (
                <>
                    {numBath} <BathIcon />
                </>
            ) : null}
        </div>
    );
}
